document.addEventListener('DOMContentLoaded', () => {
  const accordionItems = document.querySelectorAll('.accordion__item');

  accordionItems.forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('active');
    });
  });
});
